import { render, staticRenderFns } from "./BlogPostPreview.vue?vue&type=template&id=494d4554&scoped=true&"
import script from "./BlogPostPreview.vue?vue&type=script&lang=js&"
export * from "./BlogPostPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d4554",
  null
  
)

export default component.exports